import { CANDU_INLINE_PLACEHOLDER } from 'dashboard/pages/Content/pages/Snapshots/utils/useSyncInlineDocument';

export const fitIframe = (
  iframeRef: HTMLIFrameElement,
  snapshotRootEl: HTMLDivElement,
  viewportWrapperEl: HTMLElement,
  viewportContainerEl: HTMLElement,
  documentEl: HTMLElement | null,
  isFirstLoad: boolean,
) => {
  const placeholder = iframeRef.contentDocument?.getElementById(CANDU_INLINE_PLACEHOLDER);
  const viewportHeight = parseInt(window.getComputedStyle(viewportWrapperEl).height, 10);
  const viewportWidth = parseInt(window.getComputedStyle(viewportContainerEl).width, 10);

  if (placeholder && documentEl && iframeRef.contentWindow) {
    const box = placeholder.getBoundingClientRect();

    const scrollTop =
      iframeRef.contentWindow.pageYOffset ||
      iframeRef.contentWindow.document.documentElement.scrollTop ||
      iframeRef.contentWindow.document.body.scrollTop ||
      0;
    const scrollLeft =
      iframeRef.contentWindow.pageXOffset ||
      iframeRef.contentWindow.document.documentElement.scrollLeft ||
      iframeRef.contentWindow.document.body.scrollLeft ||
      0;
    const clientTop =
      iframeRef.contentWindow.document.documentElement.clientTop ||
      iframeRef.contentWindow.document.body.clientTop ||
      0;
    const clientLeft =
      iframeRef.contentWindow.document.documentElement.clientLeft ||
      iframeRef.contentWindow.document.body.clientLeft ||
      0;

    if (isFirstLoad) {
      /* eslint-disable no-param-reassign */
      snapshotRootEl.style.minHeight = '';
      snapshotRootEl.style.minWidth = '';
      // to prevent flashing in case we do have to add overflow
      viewportContainerEl.style.overflowX = 'hidden';
      /* eslint-enable no-param-reassign */
    }

    const top = box.top + scrollTop - clientTop;
    const left = box.left + scrollLeft - clientLeft;

    // add a bit of extra space for showing the content
    const minSnapshotHeight = Math.min(
      Math.abs(top) + parseInt(window.getComputedStyle(documentEl).height, 10) + 100,
      30000,
    );
    const snapshotHeight = Math.max(viewportHeight, minSnapshotHeight);

    if (snapshotHeight !== parseInt(snapshotRootEl.style.minHeight, 10)) {
      /* eslint-disable no-param-reassign */
      snapshotRootEl.style.minHeight = `${snapshotHeight}px`;
    }

    const minSnapshotWidth = Math.min(
      Math.abs(left) + parseInt(window.getComputedStyle(documentEl).width, 10),
      30000,
    );
    const snapshotWidth = Math.max(viewportWidth, minSnapshotWidth);

    if (snapshotWidth !== parseInt(snapshotRootEl.style.minWidth, 10)) {
      /* eslint-disable no-param-reassign */
      snapshotRootEl.style.minWidth = `${snapshotWidth}px`;

      if (snapshotWidth === viewportWidth) {
        viewportContainerEl.style.overflowX = '';
      } else {
        viewportContainerEl.style.overflowX = 'auto';
      }
    }

    if (isFirstLoad) {
      placeholder.scrollIntoView({ block: 'center' });
    }
  } else {
    /* eslint-disable no-param-reassign */
    snapshotRootEl.style.minHeight = '';
    snapshotRootEl.style.minWidth = '';
    viewportContainerEl.style.overflowX = '';
  }
};
